import { render, staticRenderFns } from "./RegisterSubsidiaryView.vue?vue&type=template&id=6c1355eb&"
import script from "./RegisterSubsidiaryView.vue?vue&type=script&lang=js&"
export * from "./RegisterSubsidiaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports